import React, { useState, useEffect } from 'react';
import {
  Button,
  IconButton,
  Typography,
  Grid,
  Box
} from "@mui/material";
import { useSnackbar } from 'notistack';
import { ACTIONS, MESSAGES } from '../../shared/constants';
import DataTable from '../../shared/data-table';
import {
  saveAllNewsletterTargets,
  getAllNewsletters,
  getSelectedNewsletter,
  getAllNewsletterStates,
  getAllCustomers,
  getAllNewsletterTypes,
  getAllEmployeePositions,
  getAllAirports,
  getResportStateData,
  getListAssessment,
  getAllNewsLetterContentTypes,
  getAssessmentReportByNewsletterIdData,
} from './logic';
import NewsletterSources from './newsletter-sources';
import NewsletterStateReport from './newsletter-state-report';
import NewsletterAssessmentReport from './newsletter-assessment-report';
import Edit from '@mui/icons-material/Edit';
import AddCircle from '@mui/icons-material/AddCircle';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import { FormatDateToStringComplete } from '../../shared/functions';
import ErrorSnackbar from '../error-snackbar';
import BackDrop from '../../shared/backdropDE';
import { getUser } from '../../shared/auth-service';

const Newsletter = () => {
  const user = getUser();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [reportData, setReportData] = useState(null);
  const [id, setId] = useState(null);
  const [newsletterId, setNewsletterId] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModalSource, setShowModalSource] = useState(null);
  const [showModalState, setshowModalState] = useState(null);
  const [showModalAssessment, setShowModalAssessment] = useState(null);
  const [action, setAction] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [newsletterStates, setNewsletterStates] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [newsletterTypes, setNewsletterTypes] = useState([]);
  const [employeePositions, setEmployeePositions] = useState([]);
  const [airports, setAirports] = useState([]);
  const [name, setName] = useState(null);
  const [error, setError] = useState(null);
  const [assessments, setAssessments ] = useState([]);
  const [newsLetterContentTypes, setNewsLetterContentTypes ] = useState([]);
  const [onlyEnabledCustomerEmployees, setOnlyEnabledCustomerEmployees ] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const companyId = user.countryCode.split('-')[0];
  const company = user.countryCode.split('-')[1];

  useEffect(() => {
    async function fetchData() {
      if (loading) {
        try {
          const data = await getAllNewsletters(user.employeeId, companyId);
          const newsletterStatesData = await getAllNewsletterStates();
          const customersData = await getAllCustomers(companyId);
          const newsletterTypesData = await getAllNewsletterTypes(companyId);
          const employeePositionsData = await getAllEmployeePositions(companyId);
          const airportsData = await getAllAirports(companyId);
          const assessmentData  = await getListAssessment(companyId);
          const newsLetterContentTypesData = await getAllNewsLetterContentTypes();
          setNewsLetterContentTypes(newsLetterContentTypesData); 
          setAssessments(assessmentData); 
          setEmployeePositions(employeePositionsData);
          setNewsletterStates(newsletterStatesData);
          setCustomers(customersData);
          setNewsletterTypes(newsletterTypesData);
          setAirports(airportsData);
          setData(data);
          setLoading(false);
        } catch (error) {
          setError(error.message);
          setLoading(false);
        }
      }
    }
    fetchData();
  });

 useEffect(() => {
  async function fetchRow() {
    if (id) {
      setLoadingModal(true);

      try {
        if (action === ACTIONS.VIEW_STATE) {
          const data = await getResportStateData(id);
          setReportData(data);
          setshowModalState(true);
        } else if (action === ACTIONS.VIEW_ASSESSMENT_STATE) {
          const data = await getAssessmentReportByNewsletterIdData(id);
          setReportData(data);
          setShowModalAssessment(true);
        } else if (action === ACTIONS.EDIT_SOURCES) {
          const item = await getSelectedNewsletter(id);
          setOnlyEnabledCustomerEmployees(item.onlyEnabledCustomerEmployees);
          setSelectedItem(item);
          setShowModalSource(true);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setId(null);
        setLoadingModal(false);
      }
    }
  }

  fetchRow();
}, [id]);



  const handleSaveSources = async (
    id,
    code,
    date,
    endDate,
    newsletterStateId,
    newsletterTypeId,
    name,
    customerId,
    selectedEmployeePositions,
    selectedAirports,
    assessmentId,
    newsletterContents,
    OnlyEnabledCustomerEmployees) => {

    await saveAllNewsletterTargets(
      {
        id,
        code,
        startDate: date,
        endDate,
        newsletterStateId,
        newsletterTypeId,
        name,
        customerId,
        employeePositions: selectedEmployeePositions,
        airports: selectedAirports,
        assessmentId,
        newsletterContents
      },
      company?.toLowerCase() === "talma ecuador" ? false : OnlyEnabledCustomerEmployees,
      companyId
    );
    setShowModalSource(false);
    setLoading(true);
    enqueueSnackbar(MESSAGES.SAVED);
  };

  const handleNew = async () => {
    setSelectedItem({});
    setId(null);
    setShowModalSource(true);
  };

  const handleActionButton = (e, cellValues, action) => {
    e.stopPropagation();
    setId(cellValues.row.id);
    setNewsletterId(cellValues.row.id);
    setName(cellValues.row.name);
    setAction(action);
  };

  const columns = [
    {
      field: "EditSources",
      headerName: "Editar",
      width: 60,
      sortable: false,
      renderCell: (cellValues) => {
        return <IconButton
          color="info"
          onClick={(e) => { handleActionButton(e, cellValues, ACTIONS.EDIT_SOURCES) }}
        >
          <Edit />
        </IconButton>;
      }
    },
    {
      field: "ViewState",
      headerName: "Ver",
      width: 60,
      sortable: false,
      renderCell: (cellValues) => {
        return <IconButton
          color="success"
          onClick={(e) => { handleActionButton(e, cellValues, ACTIONS.VIEW_STATE) }}
        >
          <QueryStatsIcon />
        </IconButton>;
      }
    },
    {
      field: "ViewAssessmentState",
      headerName: "Eva.",
      width: 60,
      sortable: false,
      renderCell: (cellValues) => {
        if (!cellValues.row.assessmentId)  {
          return null;
        }
        return <IconButton
          color="error"
          onClick={(e) => { handleActionButton(e, cellValues, ACTIONS.VIEW_ASSESSMENT_STATE) }}
        >
          <QuestionAnswerIcon />
        </IconButton>;
      }
    },
    { field: 'id', headerName: 'Id', width: 50 },
    { field: 'code', headerName: 'Cód. Externo', width: 180, align: 'center', headerAlign: 'center' },
    {
      field: 'newsletterTypeName', headerName: 'Tipo', align: 'center', headerAlign: 'center',
      renderCell: (cellValues) => {
        return cellValues.value ? cellValues.value.name : null;
      }, width: 100
    },
    { field: 'name', headerName: 'Nombre', width: 600 },
    {
      field: 'startDate', headerName: 'Fecha Desde', align: 'center', headerAlign: 'center',
      renderCell: (cellValues) => {
        return cellValues.value ? FormatDateToStringComplete(cellValues.value) : null;
      }, width: 110
    },
    {
      field: 'endDate', headerName: 'Fecha Hasta', align: 'center', headerAlign: 'center',
      renderCell: (cellValues) => {
        return cellValues.value ? FormatDateToStringComplete(cellValues.value) : null;
      }, width: 100
    },
    {
      field: 'customerName', headerName: 'Emisor/Cliente', align: 'center', headerAlign: 'center',
      renderCell: (cellValues) => {
        return cellValues.value ? cellValues.value.name : null;
      }, width: 250
    },
    {
      field: 'stateName', headerName: 'Estado', align: 'center', headerAlign: 'center',
      renderCell: (cellValues) => {
        return cellValues.value ? cellValues.value.name : null;
      }, width: 120
    },
    
  ];

  if (loading) {
    return (
      // <Box sx={{ display: 'flex' }}>
      //     <CircularProgress />
      // </Box>
      <BackDrop />
    );
  }

  if (error) 
    return (<ErrorSnackbar message={error} />);

  
  return (
    <>

      {loadingModal && <BackDrop />}

      {showModalAssessment && <NewsletterAssessmentReport
         name={`Estado evaluación circular ${name}`}
         reportData={reportData}
         handleClose={setShowModalAssessment}
         id={newsletterId}
      />}

      {showModalSource && <NewsletterSources
        data={selectedItem}
        handleClose={setShowModalSource}
        handleSaveSources={handleSaveSources}
        airports={airports}
        customers={customers}
        employeePositions={employeePositions}
        newsletterTypes={newsletterTypes}
        newsletterStates={newsletterStates}
        assessments={assessments}
        newsLetterContentTypes={newsLetterContentTypes}
        onlyEnabledCustomerEmployees={onlyEnabledCustomerEmployees}
        company={company}
      />}

      {showModalState && <NewsletterStateReport
        name={name}
        reportData={reportData}
        handleClose={setshowModalState}
        airports={airports}
        employeePositions={employeePositions}
      />}
      {error && <ErrorSnackbar message={error} />

      }
      <Grid container spacing={2}>
        <Grid item xs={10}>
          <Typography variant="h5" style={{ color: '#1a3072' }} fontWeight="bold" sx={{ flexGrow: 1, m: 1, }}>
            Circulares
          </Typography>
          {/* <Typography variant="h5" gutterBottom>
                {`${TITLES.NEWSLETTER}`}
              </Typography> */}
        </Grid>
        <Box sx={{ m: 4 }}>
          <Grid item xs={2}>
            <Button
              endIcon={<AddCircle />}
              variant="contained"
              onClick={() => { handleNew() }} autoFocus>{ACTIONS.NEW}</Button>
          </Grid>
        </Box>
      </Grid>
      <DataTable columns={columns} rows={data || []}
         sx={{
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold', // Aplicar negrita a los títulos de las columnas
          }
        }}
      />
    </>
  );
};

export default Newsletter;
